import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex gap-y-6 flex-col pb-6" }
const _hoisted_2 = { class: "flex gap-y-6 flex-col sm:flex-row flex-wrap pr-4" }
const _hoisted_3 = {
  key: 0,
  class: "flex gap-y-6 flex-col sm:flex-row flex-wrap pr-4"
}
const _hoisted_4 = {
  key: 1,
  class: "py-1 mr-2"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_6 = { class: "flex gap-y-6 flex-col sm:flex-row flex-wrap pr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: _ctx.detailData.data.dfdcId,
    loading: _ctx.apiDetailData.loading,
    error: !!_ctx.apiDetailData.errorType,
    errorType: _ctx.apiDetailData.errorType,
    onTryAgain: _ctx.fetchDetail
  }, {
    data: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Title, { label: "Detail Informasi Konfigurasi" }),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataWrapper, {
            class: "w-1/2",
            label: "ID Konfigurasi",
            value: _ctx.detailData.data.dfdcId
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-1/2",
            label: "Nama Konfigurasi",
            value: _ctx.detailData.data.dfdcName
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            class: "w-full",
            label: "Deskripsi Konfigurasi",
            value: _ctx.detailData.data.dfdcDescription
          }, null, 8, ["value"]),
          (!_ctx.sourceDex)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                class: "w-1/2",
                label: "Kode Alasan",
                value: _ctx.detailData.data.dfdcReasonCode
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          (!_ctx.sourceDex)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                class: "w-1/2",
                label: "Kategori Alasan",
                value: _ctx.detailData.data.dfdcReasonCategory?.toLowerCase()
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Title, { label: "Parameter" }),
        (_ctx.detailData.data.dfdcType === 'reason_closed_address')
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_DataWrapper, {
                class: "w-full",
                label: "Tipe Alamat",
                value: "Kantor"
              }),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Jam Dimulai",
                value: _ctx.detailData.data.dfdcOfficeStartTime
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Jam Berakhir",
                value: _ctx.detailData.data.dfdcOfficeEndTime
              }, null, 8, ["value"]),
              _createVNode(_component_DataWrapper, {
                class: "w-1/2",
                label: "Kecualikan Akhir Pekan & Hari Libur",
                value: 
              _ctx.detailData.data.dfdcOfficeExcludeWeekendHoliday ? 'Ya' : 'Tidak'
            
              }, null, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.detailData.data.dfdcType === 'reason_closed_address')
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_6, [
          (_ctx.detailData.data.dfdcType === 'reason_closed_address')
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                class: "w-full",
                label: "Tipe Alamat",
                value: "Rumah"
              }))
            : _createCommentVNode("", true),
          (!_ctx.sourceDex)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                class: "w-1/2",
                label: "Jam Dimulai",
                value: _ctx.detailData.data.dfdcParamStartTime
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          (!_ctx.sourceDex)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 2,
                class: "w-1/2",
                label: "Jam Berakhir",
                value: _ctx.detailData.data.dfdcParamEndTime
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          (!_ctx.sourceDex)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 3,
                class: "w-1/2",
                label: "Kecualikan Akhir Pekan & Hari Libur",
                value: 
              _ctx.detailData.data.dfdcParamExcludeWeekendHoliday ? 'Ya' : 'Tidak'
            
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          (_ctx.sourceDex)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 4,
                class: "w-1/2",
                label: "Genesis",
                value: _ctx.detailData.data.dfdcGenesis ? 'Ya' : 'Tidak'
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          (_ctx.sourceDex)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 5,
                class: "w-1/2",
                label: "Driver Apps",
                value: _ctx.detailData.data.dfdcDriverApp ? 'Ya' : 'Tidak'
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    "sub-data": _withCtx(() => [
      _createVNode(_component_DataWrapper, { label: "Status" }, {
        default: _withCtx(() => [
          _createVNode(_component_ChipsV2, {
            label: _ctx.detailData.data.dfdcStatus
          }, null, 8, ["label"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Tanggal Dibuat",
        value: _ctx.detailData.data.formatCreatedAt,
        caption: _ctx.detailData.data.dfdcCreatedBy
      }, null, 8, ["value", "caption"]),
      _createVNode(_component_DataWrapper, {
        label: "Tanggal Diperbarui",
        value: _ctx.detailData.data.formatUpdatedAt,
        caption: _ctx.detailData.data.dfdcUpdatedBy
      }, null, 8, ["value", "caption"]),
      _withDirectives(_createVNode(_component_LpButton, {
        title: "Ubah",
        customClass: "w-1/2",
        onClick: _ctx.goToEdit,
        outline: "",
        textColor: "red-lp-100"
      }, null, 8, ["onClick"]), [
        [_vShow, _ctx.isEditAble]
      ])
    ]),
    _: 1
  }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]))
}